import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./utils/ScrollToTop";
import { GlobalDebug } from "./utils/GlobalDebug";
import config from "./config";
import { UserProvider } from "./context";
import { MessageProvider } from "./context/MessageProvider";
import { PushNotificationProvider } from "./context/PushNotificationProvider";

// Disable all logs if DEBUG_MODE is false
GlobalDebug(config.DEBUG_MODE, true);

// Register service worker on page load - ALWAYS register for PWA/push to work
// Safari on Mac requires service worker for push notifications
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/sw.js')
//       .then(registration => {
//         // Use alert for debugging when console is suppressed
//         if (config.DEBUG_MODE) {
//           console.log('ServiceWorker registration successful with scope: ', registration.scope);
//         }
//       })
//       .catch(error => {
//         // Always log errors for debugging
//         console.error('ServiceWorker registration failed: ', error);
//         // Log the full error details
//         console.error('Error name:', error.name);
//         console.error('Error message:', error.message);
//       });
//   });
// } else {
//   console.error('Service Worker not supported in this browser');
// }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ScrollToTop />
    <UserProvider>
      <MessageProvider>
        <PushNotificationProvider>
          <App />
        </PushNotificationProvider>
      </MessageProvider>
    </UserProvider>
  </BrowserRouter>
);